import { create } from "zustand";

interface HookProps {
  open: boolean;
  lead: {
    id: string;
  } | null;
  setLead: (data: { id: string } | null) => void;
  onOpenChange: (open: boolean) => void;
}

export const useTakeActionModal = create<HookProps>()((set) => ({
  open: false,
  lead: null,
  setLead: (data) =>
    set(() => ({
      lead: data,
    })),
  onOpenChange: (open) =>
    set(() => ({
      open,
    })),
}));
